import { useEffect, useRef, useState } from "react";
import Confetti from "react-confetti";
import Lottie from "lottie-react";
import TreasureChest from "../../assets/lottie-json/treasure.json";

const CONFETTI_DURATION = 5000;
const TREASURE_DELAY = 600;

const CoinShower = ({ show, onHide }) => {
  const hasPlayedRef = useRef(false);
  const [confettiActive, setConfettiActive] = useState(false);
  const [treasureActive, setTreasureActive] = useState(false);

  useEffect(() => {
    if (!show) {
      hasPlayedRef.current = false;
      setConfettiActive(false);
      setTreasureActive(false);
      if (onHide) {
        onHide();
      }
      return;
    }

    if (hasPlayedRef.current) return;
    hasPlayedRef.current = true;

    setConfettiActive(true);

    const treasureTimer = setTimeout(() => {
      setTreasureActive(true);
    }, TREASURE_DELAY);

    const stopTimer = setTimeout(() => {
      setConfettiActive(false);
      setTreasureActive(false);
      if (onHide) {
        onHide();
      }
    }, CONFETTI_DURATION);

    return () => {
      clearTimeout(treasureTimer);
      clearTimeout(stopTimer);
    };
  }, [show, onHide]);

  if (!confettiActive) return null;

  return (
    <>
      <div
        style={{
          position: "fixed",
          inset: 0,
          zIndex: 10002,
          pointerEvents: "none",
          background: `
            radial-gradient(
              circle at center,
              rgba(255, 215, 0, 0.45),
              rgba(255, 193, 7, 0.35),
              rgba(255, 165, 0, 0.25),
              rgba(0, 0, 0, 0)
            )
          `,
        }}
      />

      <Confetti
        numberOfPieces={150}
        recycle={false}
        gravity={0.25}
        run={confettiActive}
        style={{ zIndex: 10003 }}
        drawShape={(ctx) => {
          ctx.beginPath();
          ctx.arc(0, 0, 14, 0, Math.PI * 2);
          ctx.fillStyle = "#fbbf24";
          ctx.fill();
        }}
      />

      {treasureActive && TreasureChest?.layers && (
        <div
          style={{
            position: "fixed",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            zIndex: 10004,
            width: 280,
            pointerEvents: "none",
          }}
        >
          <Lottie animationData={TreasureChest} loop={false} autoplay />
        </div>
      )}
    </>
  );
};

export default CoinShower;
